export default __webpack_public_path__ + "static/media/recentIcon.a25af7d9.svg";